const LogoMark = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lgm" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f5c542" />
        <stop offset="1" stopColor="#e8963c" />
      </linearGradient>
    </defs>
    <path d="M32 6 L38 26 L58 32 L38 38 L32 58 L26 38 L6 32 L26 26 Z" fill="url(#lgm)" />
    <circle cx="49" cy="15" r="3" fill="#f5c542" />
  </svg>
);

export const Logo = () => (
  <span className="inline-flex items-center gap-2" data-testid="brand-logo">
    <LogoMark className="w-6 h-6 shrink-0" />
    <span className="font-extrabold text-base tracking-tight text-white">Glow &amp; Bling</span>
  </span>
);

export default Logo;
